import { MeterType } from '@/api/baseDefine';

export class MeterUtil {
    public static getMeterTypeByMeterCounts(meterCounts: number[], meterTypeNames: string[], firstMeterTypes?: MeterType[]) {
        const metetTypes: MeterType[] = []
        for (let i = 0; i < meterCounts.length; i++) {
            if (meterCounts[i] > 0 || this.contain(i + 1, firstMeterTypes)) {
                const meterType: MeterType = {} as MeterType;
                meterType.id = i + 1;
                meterType.meterCount = meterCounts[i];
                meterType.name = meterTypeNames[i];
                metetTypes.push(meterType);
            }
        }
        return metetTypes;
    }

    public static contain(id: number, meterTypes?: MeterType[]) {
        if (!meterTypes || meterTypes.length <= 0) {
            return false;
        }
        for (const meterType of meterTypes) {
            if (id === meterType.id) {
                return true;
            }
        }
        return false;
    }
}
